import { connect } from 'react-redux';
import RemoveCertificateModal from "./RemoveCertificateModal";
import { getActiveModal, hideModal, MODAL_REMOVE_CERTIFICATE } from "../../../../reducers/common/activeModal";
import { resetSubmitFormData } from "../../../../reducers/common/submitForm";
import { getTranslation } from "../../../../reducers/common/localization";
import { fetchRemoveOrgCertificate } from '../../../../reducers/organization/orgCertificate';
import { getOrgCertificateDataById } from '../../../../reducers/organization/orgCertificate';

const mapStateToProps = (state, {certId}) => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_REMOVE_CERTIFICATE,
        translation: getTranslation(state),
        certificate: getOrgCertificateDataById(state, certId)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRemoveCertificate: (certId, orgId) => {
            dispatch(fetchRemoveOrgCertificate(orgId, certId));
        },
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCertificateModal);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/certificatesManagement/removeCertificateModal/RemoveOrgCertificateModal.container.js